import { sectionLabels } from "../section-labels";
/**
 * Collection header — locked. The page-opening block on a category/collection
 * page: title (defaults to the category name), description, and optional
 * cover image. Owns the page's `<h1>` (collection name) so it's
 * SEO-critical.
 *
 * Lives under `templates.collection` only.
 */
export const collectionHeaderSchema = {
    type: "collection-header",
    name: sectionLabels["collection-header"],
    description: {
        ar: "العنوان والوصف وصورة الغلاف لصفحة الفئة.",
        en: "Title, description, and cover image for the collection page.",
    },
    locked: true,
    criticalForSeo: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["collection"],
    settings: [
        {
            id: "showCoverImage",
            type: "checkbox",
            label: { ar: "إظهار صورة الغلاف", en: "Show cover image" },
            helpText: {
                ar: "لو ماحطّيتش صورة غلاف، هياخد صورة المنتج المميز.",
                en: "Falls back to the featured product image when no custom cover is set.",
            },
            default: true,
        },
        {
            id: "showProductCount",
            type: "checkbox",
            // F1: the count sits in `BuyerCollectionPage`'s `max-lg:hidden` header
            // band. Phones/tablets collapse to `BuyerMobilePageBar` (a back chevron +
            // the name), which never renders it — so the toggle is invisible there.
            appliesTo: ["desktop"],
            label: { ar: "إظهار عدد المنتجات", en: "Show product count" },
            default: true,
        },
        {
            id: "description",
            type: "textarea",
            i18n: true,
            // F1: same `max-lg:hidden` band as `showProductCount` above. NB the text
            // is still IN the mobile DOM (display:none, so it keeps its SEO value) —
            // `appliesTo` scopes where the CONTROL is offered, not where the value
            // applies.
            appliesTo: ["desktop"],
            label: { ar: "وصف الفئة", en: "Collection description" },
            helpText: {
                ar: "فقرة قصيرة تظهر تحت العنوان. بتفيد السيو وبتوضّح للمشتري.",
                en: "A short paragraph below the title. Helps SEO and buyer clarity.",
            },
            validate: { max: 280 },
        },
        {
            id: "headingLevel",
            type: "headingLevel",
            label: { ar: "مستوى العنوان", en: "Heading level" },
            default: 1,
        },
    ],
};
//# sourceMappingURL=collection-header.js.map